import { useEffect, useState } from 'react';
import { fetchCalleeOmnibus } from 'calling-lifecycle-internal/callee-omnibus/clients/fetchCalleeOmnibus';
import { getCallableObjectAndAssociations } from 'calling-lifecycle-internal/callee-omnibus/operators/calleeOmnibusResultGetters';
import { getCrmObjectIdAndCallerIdFromCallId } from 'calling-lifecycle-internal/caller/clients/getCrmObjectIdAndCallerIdFromCallId';
// @ts-expect-error module not typed
import { CallableObject } from 'calling-lifecycle-internal/callees/records/CalleesRecords';
import { logNetworkError } from 'calling-lifecycle-internal/utils/logNetworkError';
import { SettingsOmnibusResult } from 'calling-lifecycle-internal/settings/records/SettingsOmnibusResult';
import { useSettingsOmnibusContext } from '../contexts/SettingsOmnibusContext';
const callableObjectsMap = {};
const objectTypeIdsMap = {};
let cachedSettingsOmnibus = null;
export let FetchCallableObjectErrors;
(function (FetchCallableObjectErrors) {
  FetchCallableObjectErrors["CALLABLE_OBJECT_NOT_FOUND"] = "CALLABLE_OBJECT_NOT_FOUND";
  FetchCallableObjectErrors["NETWORK_ERROR"] = "NETWORK_ERROR";
})(FetchCallableObjectErrors || (FetchCallableObjectErrors = {}));
export const useFetchCallableObjectFromCallId = ({
  callId
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [callableObject, setCallableObject] = useState(callableObjectsMap[callId] || null);
  const [objectTypeId, setObjectTypeId] = useState(objectTypeIdsMap[callId] || null);
  const {
    setSettingsOmnibus
  } = useSettingsOmnibusContext();
  useEffect(() => {
    if (callableObjectsMap[callId] && objectTypeIdsMap[callId]) {
      setSettingsOmnibus(cachedSettingsOmnibus);
      return;
    }
    setIsLoading(true);
    getCrmObjectIdAndCallerIdFromCallId(callId).then(crmObjectIdAndCallerIdResponse => {
      const {
        objectId: _objectId,
        objectTypeId: _objectTypeId
      } = crmObjectIdAndCallerIdResponse.inboundCallerIdObjectCoordinates[0];
      setObjectTypeId(_objectTypeId);
      objectTypeIdsMap[callId] = _objectTypeId;
      if (!_objectId || !_objectTypeId) {
        setError(FetchCallableObjectErrors.CALLABLE_OBJECT_NOT_FOUND);
        setIsLoading(false);
        return;
      }
      fetchCalleeOmnibus({
        objectId: _objectId,
        objectTypeId: _objectTypeId
      }).then(calleeOmnibusResponse => {
        const callableObjectAndAssociations = getCallableObjectAndAssociations(calleeOmnibusResponse);
        const _callableObject = new CallableObject(callableObjectAndAssociations.fromObject);
        setCallableObject(_callableObject);
        callableObjectsMap[callId] = _callableObject;
        if (!_callableObject) setError(FetchCallableObjectErrors.CALLABLE_OBJECT_NOT_FOUND);
        const _settingsOmnibus = new SettingsOmnibusResult(calleeOmnibusResponse);
        setSettingsOmnibus(_settingsOmnibus);
        cachedSettingsOmnibus = _settingsOmnibus;
        setIsLoading(false);
      }).catch(networkError => {
        setError(FetchCallableObjectErrors.NETWORK_ERROR);
        setIsLoading(false);
        logNetworkError({
          networkError,
          error: new Error('Callees omnibus request failed'),
          tags: {
            requestName: '/calls/v1/callees/omnibus'
          }
        });
      });
    }).catch(networkError => {
      setError(FetchCallableObjectErrors.NETWORK_ERROR);
      setIsLoading(false);
      logNetworkError({
        networkError,
        error: new Error('Crm objectId and callerId request failed'),
        tags: {
          requestName: 'calls/v1/call/live-crm-context/${callId}'
        }
      });
    });
  }, [callId, setSettingsOmnibus]);
  return {
    isLoading,
    callableObject,
    objectTypeId,
    error
  };
};